import { Injectable } from '@angular/core';
import { AppConfigService } from '@app/modules/shared/services/app-config/app-config.service';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SignalRService {
  private hubConnection: HubConnection;
  private polizaActualizadaSubject = new Subject<any>();
  public polizaActualizada$: Observable<any> =
    this.polizaActualizadaSubject.asObservable();

  private cotizacionActualizadaSubject = new Subject<any>();
  public cotizacionActualizada$: Observable<any> =
    this.cotizacionActualizadaSubject.asObservable();

  private estimacionIngresosActualizadaSubject = new Subject<any>();
  public estimacionIngresosActualizada$: Observable<any> =
    this.estimacionIngresosActualizadaSubject.asObservable();

  constructor(private _app: AppConfigService) {}

  public async startConnection(): Promise<void> {
    try {
      const baseUrl = this._app.signalRConfig.backendBaseUrl;
      const url = `${baseUrl}/cnnSignalR`;

      this.hubConnection = new HubConnectionBuilder()
        .withUrl(url)
        .withAutomaticReconnect()
        .build();

      await this.hubConnection.start();
      console.log('Conexión con SignalR establecida');
      this.addEventListeners();
    } catch (err) {
      console.error('Error al iniciar la conexión con SignalR: ', err);
    }
  }

  private addEventListeners(): void {
    this.hubConnection.on('polizaActualizada', (dataJson: string) => {
      console.log('Poliza actualizada: ', dataJson);
      const data = JSON.parse(dataJson);
      console.log('Poliza actualizada luego de JSON.parse: ', data);
      this.polizaActualizadaSubject.next(data);
    });

    this.hubConnection.on('onAiQuoteDataChanged', (dataJson: string) => {
      console.log('Cotizacion actualizada: ', dataJson);
      const data = JSON.parse(dataJson);
      console.log('Cotizacion actualizada luego de parse: ', data);
      this.cotizacionActualizadaSubject.next(data);
    });

    this.hubConnection.on('onIncomeEstimationChanged', (dataJson: string) => {
      const data =
        typeof dataJson === 'string' ? JSON.parse(dataJson) : dataJson;
      this.estimacionIngresosActualizadaSubject.next(data);
    });
  }
}
